import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, Tooltip, Typography } from '@mui/material'
import i18n from 'simple-react-i18n'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import ColorfulCard from '../../../components/card/ColorfulCard'
import { getEventColor } from '../../../utils/ColorUtil'
import { getDate, getDateWithHourString, getHour } from '../../../utils/DateUtil'
import { rpqsEventShape } from '../../constants/RpqsShapes'
import { EVENT_SOURCE_ICONS, getEventSource } from './RpqsEventsUtils'

// Même structure que la carte d'événement des stations (classes event-card / event-content / event-footer) :
// commentaire en gras, date en dessous, origine à droite et dernière mise à jour dans le bandeau gris.
const RpqsEventCard = ({
    event = {},
    contacts = [],
    originLabel,
    small = false,
    onClick,
}) => {
    const contact = contacts.find(c => c.code === event.contactCode)
    return (
        <ColorfulCard color={getEventColor(event.eventType)}>
            <div className='event-card'>
                <Box
                    className='event-content'
                    sx={{
                        display: 'flex',
                        flexDirection: small ? 'column' : 'row',
                        alignItems: small ? 'flex-start' : 'center',
                        gap: small ? 0 : 1,
                        paddingRight: 1,
                        cursor: onClick ? 'pointer' : 'default',
                    }}
                    onClick={onClick}
                >
                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                        <h5 className='event-title' style={{ whiteSpace: 'pre-wrap' }}>{event.comment}</h5>
                        <p><i>{getDateWithHourString(event.date, event.hour)}</i></p>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: small ? 1 : 0, paddingBottom: small ? 1 : 0 }}>
                        <Icon>{EVENT_SOURCE_ICONS[getEventSource(event)]}</Icon>
                        {originLabel && <Typography>{originLabel}</Typography>}
                        {contact && (
                            <Tooltip title={contact.name}>
                                <AccountCircleIcon />
                            </Tooltip>
                        )}
                    </Box>
                </Box>
                <div className='event-footer'>
                    {event.updateDate && event.updateLogin && (
                        <div className='padding-left-2 font-size-10'>
                            {`${i18n.lastUpdateOn} ${getDate(event.updateDate)} ${i18n.atHour} ${getHour(event.updateDate)} ${i18n.by} ${event.updateLogin}`}
                        </div>
                    )}
                </div>
            </div>
        </ColorfulCard>
    )
}

RpqsEventCard.propTypes = {
    event: rpqsEventShape,
    contacts: PropTypes.arrayOf(PropTypes.shape({ code: PropTypes.number, name: PropTypes.string })),
    originLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    // carte réduite (panneau latéral) : titre, date et origine empilés
    small: PropTypes.bool,
    onClick: PropTypes.func,
}

export default RpqsEventCard
